import React from "react";
import { ERROR_MESSAGE_CLASS } from "./constants";

const InputErrorMessage = ({ errorMessage }) => {
    return <p className={ERROR_MESSAGE_CLASS}>{errorMessage}</p>;
};

export default InputErrorMessage;
